import {React,useState} from 'react';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import { 
  HomeOutlined, 
  AppstoreAddOutlined, 
  AppstoreOutlined, 
  CodeOutlined, 
  UsergroupAddOutlined, 
  TeamOutlined, 
  BranchesOutlined, 
  MailOutlined, 
  EnvironmentOutlined, 
  MenuOutlined
} from '@ant-design/icons';  // Importing the Ant Design icons
import './sidebar.css';
import { Menu, Tooltip } from 'antd';
const items = [
  {
    key: 'mail',
    icon: <MailOutlined />,
  },
  {
    key: 'app',
    icon: <AppstoreOutlined />,
  },
]


const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  return (
    <>
    <div id="mySidenav" className="sidenav">
      <Tooltip placement="left" title="Home">
      <Link to="/" id="home">
        <HomeOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Vision-Mission">
      <Link to="/visionmission" id="visionandmission">
        <AppstoreAddOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Core-Values">
      <Link to="/corevalues" id="corevalues">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Core-Competencies">
      <Link to="/corecompetencies" id="corecompetencies">
        <AppstoreAddOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Our-Products">
      <Link to="/products" id="products">
        <AppstoreOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Technologies">
      <Link to="/technologies" id="technologies">
        <CodeOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Clients">
      <Link to="/clients" id="clients">
        <UsergroupAddOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Partners">
      <Link to="/partners" id="partners">
        <TeamOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Clientele">
      <Link to="/trainingclient" id="clientele">
        <BranchesOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Our-Branches">
      <Link to="/locations" id="locations">
        <EnvironmentOutlined style={{ fontSize: '1.5rem' }} /> 
      </Link>
      </Tooltip>
      <Tooltip placement="left" title="Contact-Us">
      <Link to="/contactus" id="contactus">
        <MailOutlined style={{ fontSize: '1.5rem' }} />  
      </Link>
      </Tooltip>
    </div>




</>
  );
};

export default Sidebar;
